import { updateTxpFlagV2 } from 'owa-txp-option/lib/actions/txpOptionsActions';
import { TxpEventFlagsV2 } from 'owa-txp-option/lib/utils/getTxpFlagInfo';
import getTxpSettings from 'owa-calendar-configuration/lib/utils/getTxpSettings';
import isTxpDisabled from './isTxpDisabled';

export default function updateLocalTxpSettings() {
    // we update the local store so that we can do a diff on which settings have been changed on save
    const txpSettings = getTxpSettings();
    if (txpSettings && !isTxpDisabled(txpSettings.TxpDisableReason)) {
        Object.keys(txpSettings.EntityTypeProcessorLevelSettings).map(eventType => {
            updateTxpFlagV2(
                eventType as TxpEventFlagsV2,
                null,
                txpSettings.EntityTypeProcessorLevelSettings[eventType]
            );
        });
        updateTxpFlagV2(
            'CreateEventsFromEmailAsPrivate',
            txpSettings.CreateEventsFromEmailAsPrivate
        );
    }
}
